__turbopack_context__.v({
  "body": "MeasureFeatureCarousel-module__sKw5jq__body",
  "card": "MeasureFeatureCarousel-module__sKw5jq__card",
  "copy": "MeasureFeatureCarousel-module__sKw5jq__copy",
  "linkRow": "MeasureFeatureCarousel-module__sKw5jq__linkRow",
  "media": "MeasureFeatureCarousel-module__sKw5jq__media",
  "mediaShimmer": "MeasureFeatureCarousel-module__sKw5jq__mediaShimmer",
  "title": "MeasureFeatureCarousel-module__sKw5jq__title",
});
